module.exports = __webpack_public_path__ + "img/files-2.b6c0e8dd.svg";